var _circle, _circle2, _path, _path2, _circle3, _circle4, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationOtp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 368,
    viewBox: "0 0 428 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.333,
    cy: 278.667,
    r: 66.6667,
    fill: "#FCE4EC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.333,
    cy: 278.667,
    r: 66.6667,
    fill: "#FCE4EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8477 222.43C96.6114 217.475 105.47 214.083 114.979 212.699L100.105 340.664C91.2947 337.17 83.4061 331.853 76.9048 325.179L88.8477 222.43Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.848 222.43C296.611 217.475 305.47 214.083 314.979 212.699L300.105 340.664C291.295 337.17 283.406 331.853 276.905 325.179L288.848 222.43Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.333,
    cy: 278.667,
    r: 66.6667,
    stroke: "#EC407A",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.333,
    cy: 278.667,
    r: 66.6667,
    stroke: "#EC407A",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183 278.667C188.556 273.111 195.5 262 216.334 262C237.167 262 244.111 273.111 249.667 278.667",
    stroke: "#EC407A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208 128.667C288.987 128.667 332.007 149.032 404.189 185.095C405.133 185.567 404.819 187 403.764 187H12.2361C11.1808 187 10.8674 185.567 11.8114 185.095C83.9929 149.032 127.013 128.667 208 128.667Z",
    fill: "#EC407A",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.111 13.3355C141.221 12.6719 141.942 12.3046 142.544 12.6055L190.269 36.4679C190.953 36.8097 191.741 36.8777 192.473 36.6581L273.579 12.3261C274.156 12.1531 274.754 12.5255 274.853 13.1196L291.139 110.836C291.241 111.445 290.771 112 290.153 112H125.847C125.229 112 124.759 111.445 124.861 110.836L141.111 13.3355Z",
    fill: "#EC407A",
    fillOpacity: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationOtp);
export default __webpack_public_path__ + "static/media/illustration_otp.81cdd7a8e1238c0f9d86f6b28a7e4343.svg";
export { ForwardRef as ReactComponent };